import React from 'react';
import type { ReactNode } from 'react';
import type { EditorBlock } from '@/store/editorSlice';
import { arrangeFlexSpacers } from '@/components/screen-layout/flexSpacer';
import {
  contentCardStyle,
  readScreenContentCard,
} from '@/player/screenContentCard';

/**
 * Раскладка содержимого экрана квиза с карточкой вокруг (задание
 * stylepack/content-card, слово владельца 21.10.2026: у Virta, Brainway,
 * Moonbird, Dance-bit заголовок, текст и картинка — в одной светлой карточке,
 * «Continue» под ней).
 *
 * Нет карточки (или поле не объект) — узлы идут в прежнюю раскладку гибких
 * отступов без единого нового узла: разметка выкаченных воронок прежняя.
 * Карточка есть — все узлы, кроме главной кнопки `button_next` (и прибитой к
 * низу), — в одной карточке, кнопки после неё в прежнем порядке. Карточка —
 * обычный узел колонки контента: высота по содержимому, и ось «по центру»
 * двигает её целиком. Все блоки карточки скрыты — пустой карточки нет.
 *
 * Граница: гибкий отступ внутри карточки места не распределяет — карточка не
 * растягивается по высоте экрана (высота по содержимому — условие задания).
 */
export function arrangeScreenContent(
  rawCard: unknown,
  blocks: readonly EditorBlock[],
  nodes: readonly ReactNode[],
): ReactNode {
  const card = readScreenContentCard(rawCard);
  if (!card) return arrangeFlexSpacers(blocks, nodes);
  const inner: EditorBlock[] = [];
  const innerNodes: ReactNode[] = [];
  const outside: ReactNode[] = [];
  blocks.forEach((block, i) => {
    if (block.type === 'button_next') outside.push(nodes[i]);
    else if (nodes[i] != null) {
      inner.push(block);
      innerNodes.push(nodes[i]);
    }
  });
  if (innerNodes.length === 0) return outside;
  return [
    <div
      key="screen-content-card"
      data-testid="screen-content-card"
      style={contentCardStyle(card)}
    >
      {arrangeFlexSpacers(inner, innerNodes)}
    </div>,
    ...outside,
  ];
}
